import React, { useState, useEffect } from "react";
import {
  Button,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  InputLabel,
  FormControl,
} from "@mui/material";
// import Groupmodalimg from "../../Assets/Images/groupmodalimg.png";
import Groupmodalimg from "../../Assets/svgs/groupmodalimage.svg";
import ModalComp from "../Modal";

export default function ViewgroupScreens({
  data,
  groupdata,
  getgroupscreens,
  open,
  onClose,
  mapscreenfunction,
  GetCookie,
  displaymapbutton,
  disabledbtn,
  LoadingSpinner,
}) {
  const [screenOptions, setScreenOptions] = useState([]);
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [errormessage, seterrormessage] = useState('');
  const [assignedScreens, setAssignedScreens] = useState([]);
  const [viewassignScreens, setviewassignScreen] = useState([]);
  const [dismapbtn, setdismapbtn] = useState(disabledbtn);
  const [isloading, setloading] =useState(true);



  useEffect(() => {
    const fetchAssignedScreens = async () => {
      if (!groupdata?.[0]?.value) return;

      const formObj = new FormData();
      formObj.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      formObj.append("security_token",await GetCookie("es_token"));
      formObj.append("ser_collection_id", groupdata?.[0]?.value);

      try {
        const returned = await getgroupscreens(formObj).unwrap();
        if (returned.status === "true" && Array.isArray(returned.data)) {

          // const alloptions = returned.data.map((screen) => String(screen.ser_screen_id));
          const assigned = returned.data.map((screen) => {
            if (screen.ser_collection_id === groupdata?.[0]?.value) {
              return String(screen.ser_screen_id);
            }
            // return null;
          });
         const assigned1 = returned.data.reduce((acc, screen) => {
            if (screen.ser_collection_id === groupdata?.[0]?.value) {
              acc.push(String(screen.txt_screen_name));
            }
            return acc;
          }, []);
          const options = returned.data.map((screen) => ({
              value: String(screen.ser_screen_id),
              label: screen.txt_screen_name,
            }));
          //Set the selected Screens Data Id
          setSelectedScreens(assigned);
          setAssignedScreens(assigned);
          //Set the selected Screens Data Text name For View the Assigned Screen on Edit Media
          setviewassignScreen(assigned1);
          setScreenOptions(options);
          seterrormessage('');
          setdismapbtn(true);
          setloading(false);
        }else{
            setloading(false);
            setSelectedScreens([]);
            setScreenOptions([]);
            seterrormessage(returned.message);
        }
      } catch (err) {
        setloading(false);
        console.error("Error fetching assigned screens", err);
      }
    };

    fetchAssignedScreens();
  }, [groupdata,open]);

  const handleScreensChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedScreens(typeof value === "string" ? value.split(",") : value);
    const selected = (typeof value === "string" ? value.split(",") : value).filter(Boolean);
    setdismapbtn(selected.length === 0);
  };

  return (
    <ModalComp
      open={open}
      onCloseModal={onClose}
      modalwidth="40%"
      modalheight="550px"
      closeicon={true}
    >
      <div className="d-flex flex-column justify-content-center align-items-center py-4">
        <div
          className="d-flex flex-column justify-content-center align-items-center gap-3 w-75"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          <img src={Groupmodalimg} width={151} height={151} alt="Group" />
          <h3 className="fs-24 fw-semibold">
            {displaymapbutton
              ? "Add "
              : "Assigned "
            } Screens to {groupdata?.[0]?.label || "Group"}
          </h3>
          <p className="text-center fs-16" style={{ color: "#00000099" }}>
          {displaymapbutton
              ? "Select screen(s) to add to this group."
              : "These are the screens currently assigned to this group"
            }
          </p>
            {errormessage &&(
              <span className="statuserror">{errormessage}</span>
            )}
            {displaymapbutton ?
            <>
          <FormControl sx={{ m: 1, width: "100%" }}>
            <InputLabel id="select-screens-label">Select the Screen</InputLabel>
            {isloading ? <LoadingSpinner /> : null}
            <Select
              labelId="select-screens-label"
              multiple
              value={selectedScreens}
              onChange={handleScreensChange}
              renderValue={(selected) =>
                selected
                  .map((id) => screenOptions.find((opt) => opt.value === id)?.label)
                  .filter(Boolean)
                  .join(", ")
              }
              label="Select the Screen"
            >
             {screenOptions &&
               (displaymapbutton
                ? screenOptions
                : screenOptions.filter((option) => selectedScreens.includes(option.value))
               ).map((option) => {
                const isAlreadyAssigned = assignedScreens.includes(option.value); 
                return (
                 <MenuItem key={option.value} value={option.value} disabled={isAlreadyAssigned}>
                <Checkbox
                  checked={selectedScreens.includes(option.value)}
                  disabled={isAlreadyAssigned}
                  color="primary"
                />
                <ListItemText primary={option.label} />
              </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          
          <Button
            variant="contained"
            sx={{ width: "100%", mt: 2 }}
            // disabled={selectedScreens.length === 0}
            // disabled={!selectedScreens.some(item => item)}
            disabled= {dismapbtn}
            onClick={() => mapscreenfunction(selectedScreens)}
            className="capitalized fs-14 fw-bold"
          >
            Map
          </Button>
          </>
         : (
            <>
              {viewassignScreens && viewassignScreens.map((screenname, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex w-100 justify-content-start py-2 px-3"
                    style={{
                      border: '1px solid #1976D2',
                      borderRadius: '6px'
                    }}
                  >
                    <div className="fs-18">{screenname}</div>
                  </div>
                );
              })}
            </>
          )
        }
        </div>
      </div>
    </ModalComp>
  );
}

